import React from 'react';

import { states } from 'utils';
import { FormSelect } from 'widgets';

export const StateSelector = ({ name, label }: { name: string; label: string }) => {
    return (
        <FormSelect name={name} label={label}>
            <option></option>
            {states.map(({ name: stateName, abbreviation }) => (
                <option key={abbreviation} value={abbreviation}>
                    {stateName}
                </option>
            ))}
        </FormSelect>
    );
};
